import store from '@/store'
import {formatRoutes, getLoginPathByRole} from '@/utils/router/other'

// 登录前路由
let before = [
  // 租户/诊所代理人 登录页
  {
    path: '/:nameCode/login',
    name: 'Login',
    component: () => import('@/views/login')
  },
  // 平台管理登录页
  {
    path: '/login/platform',
    name: 'LoginPlatform',
    component: () => import('@/views/login/platform')
  }
]

// 登录页
export const loginList = ['Login', 'LoginPlatform']

export default before.concat(formatRoutes(store.state.login.routes))

/**
 * 路由拦截
 */
export const interceptor = (to, next) => {
  let goNext = () => {
    if (loginList.indexOf(to.name) > -1 || to.path === '/') {
      next('/home/index')
    } else {
      next()
    }
  }

  let goLogin = () => {
    store.dispatch('FedLogOut').then(() => {
     next(getLoginPathByRole())
    })
  }
  const loginData = store.state.login.loginData
  if (loginData && loginData.length > 0) {
    if (to.path === '/login') {
      next()
    } else {
      next('/login')
    }
    return
  }
  const userCode = store.state.login.userInfo.userCode

  // 判断是否登录
  if (userCode) {
    goNext()
  } else {
    goLogin()
  }
}



// WEBPACK FOOTER //
// ./src/router/login.js